import { render } from "./inquiry-com.vue?vue&type=template&id=31fcacd6&scoped=true"
import script from "./inquiry-com.vue?vue&type=script&lang=js"
export * from "./inquiry-com.vue?vue&type=script&lang=js"

import "./inquiry-com.vue?vue&type=style&index=0&id=31fcacd6&scoped=true&lang=css"

import exportComponent from "/Users/achinthaprabasha/Desktop/work/yathra/yathra-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31fcacd6"]])

export default __exports__